/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserContextAttributes } from './types';
import { getUserContext } from './dispatcher';

export const pushDataLayer = <T extends Record<string, any>>(
  event: string,
  data: T & Partial<UserContextAttributes>,
) => {
  const timestamp = new Date().getTime().toString();

  const user = getUserContext();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...user,
    ...data,
    timestamp,
  });
};

export const createUndefinedObject = <T extends Record<string, any>>() => {
  return new Proxy({} as { [K in keyof T]: undefined }, {
    get: () => undefined,
  });
};

export const getTimestamp = (startDate: number, endDate: number) => {
  return Math.abs((endDate - startDate) / 1000);
};
